<head>
	<title>臺中市交通行動服務(MAAS)_旅運規劃</title>
</head>
<div [class.home]='state >= 3'>
    <div  class="mapbox">
        <div class="detail" [class.no]='state >= 3' >
             <!---起點、終點輸入框-->
            <div class="route_box" [class.d-none]="state >= 3">
                <div class="mapline">

                    <div class="route01">
                        <div class="icon"><img src="/static/images/svg/ic_RouteStart.svg" alt="起點"></div>
                        <input type="text" id="startPoint" placeholder="請輸入起點" class="w-100">
                    </div>

                    <div class="route02">
                        <div class="icon"><img src="/static/images/svg/ic_RouteEnd.svg" alt="終點"></div>
                        <input type="text" id="endPoint" placeholder="請輸入終點" class="w-100">
                    </div>

                </div>

                <div class="btn_turn"><a (click)="changePlace()" role="button"><img src="/static/images/svg/ic_BtnTurn.svg" alt="翻轉"/></a></div>
            </div>
            <!---搜尋條件輸入框-->
            @if(state == 1 || state == 2){
            <div>
                <train-option (callBack)="showDetail($event.option)"></train-option>
            </div>
            }

            <!---搜尋結果-->
            @if(state >= 3){
            <div>
                <train-detail [startLocation]="this.startLocation"  [endLocation]="this.endLocation" [detailArray]="this.detailArray" (callBack)="detailBack($event.state, $event.num)"></train-detail>
                <train-attraction [attractionArray]="this.attractionArray"></train-attraction>
            </div>
            }
        </div>



        <div class="mapimg" [class.bk]='state == 2' (click)="checkWarn()">
            <!---錯誤訊息-->
            @if(state == 2){
            <div class="warn"><img src="/static/images/svg/ic_warn.svg" alt="提示"><p>{{ errorMessage }}</p></div>
            }
            <div class="map_in">
                <train-google-map [startLocation]="this.startLocation"  [endLocation]="this.endLocation" [detail]="this.detailObject" [attractionArray]="this.attractionArray" [state]="this.state"></train-google-map>
            </div>
        </div>
    </div>
</div>
